module.exports = __webpack_public_path__ + "0053153267458c53931080fdeb4f969d.svg";